<template>
  <p>Stopwords are words that are filtered out before processing any of your text. None of the words in the stopword list will appear in your topic model for an analysis.</p>
</template>